"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var react_native_1 = require("react-native");
var ThemeProvider_1 = require("../theme/ThemeProvider");
var SpacingSizesEnum_1 = require("../enums/SpacingSizesEnum");
var defaultProps = {
    type: SpacingSizesEnum_1.SpacingSizesEnum.base
};
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
exports.SpacingView = native_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  height: ", "px;\n"], ["\n  width: 100%;\n  height: ", "px;\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), function (props) { return props.height; });
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLSpacing = function (_a) {
    var type = _a.type;
    var theme = ThemeProvider_1.useTheme();
    var height;
    switch (type) {
        case SpacingSizesEnum_1.SpacingSizesEnum.base:
            height = theme.SpacingBase;
            break;
        case SpacingSizesEnum_1.SpacingSizesEnum.marginal:
            height = theme.SpacingMarginal;
            break;
        case SpacingSizesEnum_1.SpacingSizesEnum.distribute:
            height = theme.SpacingDistribute;
            break;
        case SpacingSizesEnum_1.SpacingSizesEnum.intersection:
            height = theme.SpacingIntersection;
            break;
        case SpacingSizesEnum_1.SpacingSizesEnum.wide:
            height = theme.SpacingWide;
            break;
    }
    return react_1.default.createElement(exports.SpacingView, { height: height });
};
exports.ATLSpacing.defaultProps = defaultProps;
exports.ATLSpacing.displayName = 'ATLSpacing';
var templateObject_1;
